import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.timers";

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
var retryPromise = function retryPromise(fn) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  return new Promise(function (resolve, reject) {
    return fn().then(resolve)["catch"](function (error) {
      if (retries === 0) {
        reject(error);
        return;
      }

      setTimeout(function () {
        retryPromise(fn, retries - 1, interval).then(resolve, reject);
      }, interval);
    });
  });
};

export default retryPromise;